module.exports = __webpack_public_path__ + "img/daffodil-goingtothedoctor.2797a7a8.png";